// extracted by mini-css-extract-plugin
export default {"mainContainer":"uSKXdtdGpGwjE6klK2xV","fallback":"_TGMe9bem8YqX9LjIExY"};